import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-tab',
  standalone: true,
  template: `
    <ng-template #tmp><ng-content></ng-content></ng-template>
  `,
})
export class AuxTabComponent {
  label = input.required<string>();

  tmp = viewChild.required<TemplateRef<unknown>>('tmp');

  @Input() pendoTag = '';
}
